import {Dialog} from "./Dialog";
import React, {useEffect, useState} from 'react'
import ReactDOM from 'react-dom'
import './style.css'

const imgSRC = 'data:image/png;base64,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'

class Modal extends React.PureComponent {
    // 渲染底部按钮
    renderFooter = () => {
        const {onOk, onCancel, cancelText, okText, footer,onClose} = this.props
        //    触发onOk / onCancel回调
        if (footer && React.isValidElement(footer)) return footer
        return <div className="model_bottom">
            <div className="model_btn_box">
                <div className="searchbtn"
                        onClick={() => onClose && onClose()}>{okText || '确定'}
                </div>
            </div>
        </div>
    }

    // 渲染底部
    renderTop = () => {
        const {title, onClose} = this.props
        return <div></div>
    }

    // 渲染弹窗内容
    renderContent = () => {
        const {content, children} = this.props
        return React.isValidElement(content) ? content : children ? children : null
    }
	// <img src='https://campaigns-static.volvocars.com.cn/image/images/retention_success_pc.png'/>
	renderSuccess = () => {
	    const {title, onClose} = this.props
	    return <div className="model_success">
		   <img src={imgSRC}/>
		   <div>预约成功</div>
		</div>
	}
	
	
	renderPolicy = () => {
	    const {title, onClose} = this.props
	    return <div className="model_policy">
		  <div>请阅读并勾选沃尔沃汽车 </div>
		  <div>《预约试驾隐私政策》</div>
		</div>
	}

    render() {
        const {visible, width = 500, closeCb, onClose,state} = this.props
		if(state == '隐私政策'){
			return <Dialog
			    closeCb={closeCb}
			    onClose={onClose}
			    visible={visible}
			    width={width}
			>
			    {this.renderTop()}
			    {this.renderPolicy()}
				{this.renderFooter()}
			</Dialog>
		}else if(state == '成功'){
			return <Dialog
			    closeCb={closeCb}
			    onClose={onClose}
			    visible={visible}
			    width={width}
			>
			    {this.renderTop()}
			    {this.renderSuccess()}
			</Dialog>
		}else{
			return <Dialog
			    closeCb={closeCb}
			    onClose={onClose}
			    visible={visible}
			    width={width}
			>
			    {this.renderTop()}
			    {this.renderContent()}
			    {this.renderFooter()}
			</Dialog>
		}
    }
}


// 静态方法
let ModalContainer = null
const modelSymbol = Symbol('$$_model_Container_hidden')

// 静态属性show——控制
Modal.show = (config) => {
    //  如果modal已经存在，name就不需要第二次show
    if (ModalContainer) return
    const props = {...config, visible: true}
    const container = ModalContainer = document.createElement('div')
    // 创建一个管理者，管理model状态
    const manager = container[modelSymbol] = {
        setShow: null,
        mounted: false,
        hidden() {
            const {setShow} = manager
            setShow && setShow(false)
        },
        destroy() {
            //    卸载组件
            ReactDOM.unmountComponentAtNode(container)
            // 移除节点
            document.body.removeChild(container)
            // 置空元素
            ModalContainer = null
        }
    }

    const ModelApp = (props) => {
        const [show, setShow] = useState(false)
        manager.setShow = setShow
        const {visible, ...trueProps} = props
        useEffect(() => {
            // 加载完成，设置状态
            manager.mounted = true
            setShow(visible)
        }, [])
        return <Modal {...trueProps} closeCb={() => manager.mounted && manager.destroy()} visible={show}/>
    }
    // 插入到body中
    document.appendChild(container)
    // 渲染React元素
    ReactDOM.render(<ModelApp/>, container)
    return manager
}

Modal.hidden = () => {
    if(!ModalContainer) return
    // 如果存在ModalContainer 那么隐藏ModalContainer
    ModalContainer[modelSymbol] && ModalContainer[modelSymbol].hidden()
}

export default Modal

